var m;

m = require('mithril');

module.exports = {
  view: function(ctrl, args) {
    return m('.HeadingBar', [m('.HeadingBar__heading', args.content), m('.HeadingBar__options', args.options)]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9IZWFkaW5nQmFyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3VpL2NvbXBvbmVudHMvSGVhZGluZ0Jhci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBRUosTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7V0FDTCxDQUFBLENBQUUsYUFBRixFQUFpQixDQUNoQixDQUFBLENBQUUsc0JBQUYsRUFBMEIsSUFBSSxDQUFDLE9BQS9CLENBRGdCLEVBRWhCLENBQUEsQ0FBRSxzQkFBRixFQUEwQixJQUFJLENBQUMsT0FBL0IsQ0FGZ0IsQ0FBakI7RUFESyxDQURVIn0=
